module.exports = __webpack_public_path__ + "assets/img/email.5bfc8cd8.svg";